import QuoteIDCard from './QuoteIDCard'

export default QuoteIDCard
